export default __webpack_public_path__ + "static/media/alarm-clock.36480f60.png";